/**
 *
 * styled
 *
 */
import { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';
import styled from 'styled-components/macro';

export const CatalogWrapper = styled.div`
  border-radius: 0px 0px 20px 20px;
  background: #ffffff;
  .mobile-box {
    background: #fff;
    border: 1px solid #e7e7e7;
    min-height: 44px;
    border-radius: 10px;
    padding: 10px;
    word-break: break-all;
  }
  .--custom-input-calender {
    width: 350px;
    font-family: 'Be Vietnam Pro, sans-serif';
  }
  .datepicker-input::placeholder {
    color: #808080 !important;
    opacity: 0.9 !important;
    font-family: 'Be Vietnam Pro', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }
  .product-ticket {
    width: 100%;
  }
  .order-info {
    padding: 0px 32px;
    position: sticky;
    display: flex;
    flex-direction: row;
    z-index: 10;
    justify-content: space-between;
    background: #ffffff;
    width: 100%;
  }
  .box-order-total {
    width: 300px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ant-form-item-has-error {
    .ant-select.ant-select-selector {
      border-bottom: solid 1px #ff4d4f;
    }
    .ant-select-disabled {
      border-bottom: solid 1px #ff4d4f;
    }
    .ant-select-selector {
      border-bottom: 0px;
    }
    .datepicker-input {
      border-color: #ff4d4f !important;
    }
  }
  .itemShow {
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px !important;
    &:last-child {
      margin-bottom: 0 !important;
    }
    .--img {
      max-width: 50%;
      img {
        width: auto;
        height: 100%;
        max-width: 100%;
        object-fit: contain;
      }
    }
    .--txt {
      padding: 16px 20px;
      width: 100%;
    }
    .--name {
      font-size: 18px;
      font-weight: 900;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 24px;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    article {
      overflow: hidden;
      margin-bottom: 1rem;
      text-overflow: ellipsis;
      line-height: 20px;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .--price {
      color: #a6a6a6;
      span {
        color: var(--color-1);
        margin-left: 8px;
      }
    }
    .--btnGroup {
    }
    @media (max-width: 768px) {
      .--btnGroup {
        margin-top: 1rem;
      }
      .--img {
        max-width: none;
        width: 100%;
      }
    }
  }
  .itemFilterField {
    margin-top: 12px;
    align-items: baseline;
    .--label {
      width: 90px;
      font-weight: 600;
      margin-right: 12px;
    }
    .--dataList {
      width: 100%;
    }
  }
  .itemDataPiece {
    background: #f2f2f2;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    padding: 4px 10px;
    margin-right: 6px;
    margin-bottom: 8px;
    width: 104px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    &:last-child {
      margin-right: 0;
    }
    &.active,
    &:hover {
      background: rgba(249, 178, 23, 0.1);
      border: 1px solid var(--color-4);
      border-radius: 4px;
      color: var(--color-4);
    }
    &.--type-timeSlot {
      width: max-content;
    }
    &.--type-calendar {
      border: 1px solid #e7e7e7;
      border-radius: 6px;
      // padding: 0 20px;
      width: 150px;
      height: 58px;
      margin-right: 8px;
      cursor: pointer;
      margin-bottom: 8px;
      transition: all 0.15s ease;
      &:nth-child(5n) {
        margin-right: 0;
      }
      .--time {
        line-height: 1;
        display: flex;
        flex-flow: column;
        margin-right: 12px;
        text-align: left;
        span {
          font-size: 14px;
          &:nth-child(1) {
            margin-bottom: 4px;
          }
          &:nth-child(2) {
            color: #ababab;
          }
        }
      }
      .--day {
        font-size: 46px;
        line-height: 46px;
      }
      &.active,
      &:hover {
        background: rgba(249, 178, 23, 0.1);
        border: 1px solid var(--color-4);
        .--time {
          span {
            &:nth-child(1) {
              color: var(--color-4);
            }
          }
        }
        .--day {
          color: var(--color-4);
        }
      }
    }
    @media (max-width: 768px) {
      &.--type-calendar {
        margin-right: 8px !important;
        width: calc(50% - 4px);
        &:nth-child(2n + 2) {
          margin-right: 0 !important;
        }
      }
    }
  }

  .catalogShowBody {
    .--title {
      font-weight: 900;
      margin-bottom: 20px;
    }
    .--listing {
    }
  }

  .catalogTicket {
    padding: 42px 0;
  }

  .catalogTicketBody {
  }

  .catalogTicketIntro {
    .--header {
      margin-bottom: 0.75rem;
    }
    .--back {
      background: #f2f2f2;
      border: 1px solid #e7e7e7;
      border-radius: 100px;
      height: 32px;
      padding: 0 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      width: max-content;
      span {
        line-height: 1;
      }
      i {
        margin-right: 10px;
        font-size: 12px;
      }
    }
    .--title {
      font-weight: 900;
      margin: 0;
    }
    .--content {
      display: flex;
      justify-content: space-between;
      background: #ffffff;
      box-shadow: 0px 4px 16px rgb(0 0 0 / 10%);
      border-radius: 8px;
      padding: 16px;
      height: max-content;
      margin-bottom: 20px;
      .--img {
        width: 220px;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        min-height: 108px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      article {
        width: calc(100% - 284px);
        position: relative;
        &::after {
          border-left: 1px dashed #c9c9c9;
          content: '';
          position: absolute;
          top: 0;
          right: calc(100% + 32px);
          height: 100%;
        }
      }
    }
    @media (max-width: 768px) {
      .--content {
        flex-flow: column;
        .--img,
        article {
          width: 100%;
        }
        .--img {
          margin-bottom: 0.75rem;
        }
      }
    }
  }

  .catalogTicketFilter {
    background: #ffffff;
    box-shadow: 0px 4px 16px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 2px 16px 8px;
    margin-bottom: 20px;
    .itemFilterField {
      border-bottom: 1px solid #eee;
      margin-bottom: 0.5rem;
      &:last-child {
        border: none;
      }
    }
  }
  .catalogTicketHead {
    .list_allservice {
      .thunder {
        position: absolute;
        top: 16px;
        left: 16px;
        border-radius: 100px;
        background: var(--color-1);
        text-transform: uppercase;
        font-size: 14px;
        color: #fff;
        padding: 4px 10px;
        display: flex;
        align-items: center;
        img {
          width: 10px;
        }
        span {
          margin-left: 6px;
        }
      }
      .check {
        display: block;
      }
      .priceold {
        position: relative;
        font-size: 14px;
        &:after {
        }
      }
    }
    @media (max-width: 768px) {
      padding: 0 6px;
      .list_allservice {
        .col-6 {
          width: 100%;
        }
        .row {
          padding: 0 12px;
        }
        .itemProduct {
          margin: 0;
          .--bill {
            flex-direction: unset !important;
            align-items: center !important;
          }
        }
      }
    }
  }
  .titleHeader {
    width: 110px;
    .--title {
      margin-left: 4px;
      font-size: 18px;
      font-weight: 600;
      color: #424242;
      margin-top: 4px;
    }
  }
  .container-search {
    background: #ffffff;
    height: 116px;
    padding: 36px 42px;
    border-radius: 20px;
    margin-bottom: 24px;
  }
  .btn-search {
    background: #e92127;
    color: #ffffff;
    height: 44px;
    width: 102px;
    padding: 8px 3px;
    border-radius: 5px;
    border: none;
  }
  .calender {
    width: 100%;
    .react-datepicker-popper {
      z-index: 11;
    }
  }
  .react-datepicker__input-container {
    color: #000000;
    font-size: 14px;
  }
  .ticket-form {
    .ant-radio-group {
      display: flex;
      flex-wrap: wrap;
      .ant-radio-wrapper {
        white-space: nowrap;
        color: #000000;
        width: auto;
      }
    }
  }
  .order-info-box-left {
    color: #000000;
  }
  .txt-order-label {
    font-size: 14px;
    font-weight: 600px;
    margin: 0px;
    margin-right: 20px;
    width: 188px;
    font-family: 'Be Vietnam Pro', sans-serif;
    color: #000000;
  }
  .txt-order-number {
    font-size: 14px;
    color: #e92227;
    margin: 0px;
    font-weight: 500;
  }
  .box-order-label {
    min-height: 25px;
    color: #000000;
    font-size: 14px;
  }
  .ticketHead {
    flex-flow: row wrap;
    column-gap: 10px;
    gap: 10px 15px;
    background: #ffffff;
    padding-bottom: 0px;
    border-radius: 16px 16px 0px 0px;
    .--title {
      font-size: 20px;
      font-weight: 600;
    }
    .--currentSelectedDate {
      width: 380px;
      background: #ffffff;
      border-radius: 10px;
      height: 45px;
      border: none;
      padding: 0px 16px;
      border: 1px solid #d9d9d9;
      &:focus {
        outline: none;
        box-shadow: 0 0 0 1px var(--color-4);
      }
      .react-datepicker__header {
        text-align: center;
        background-color: #f0f0f0;
        border-top-left-radius: 0.3rem;
        padding: 8px 0;
        position: relative;
        border-bottom: none;
      }
      input {
        width: 306px;
        border: none;
        outline: none;
      }
      i {
        pointer-events: none;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 6px 6px 0;
      }
      .react-datepicker__header {
        background: #fff;
      }
      .react-datepicker__portal > div {
        padding: 16px;
        border-radius: 12px;
      }
      .react-datepicker__portal {
        background: rgb(0 0 0 / 50%);
      }
      .react-datepicker__month-container {
        background: #fff;
        .react-datepicker__day.react-datepicker__day--keyboard-selected {
          background-color: inherit;
          color: inherit;
          font-weight: inherit;
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected- {
          background-color: inherit;
          color: inherit;
          font-weight: inherit;
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range {
          background: #fef2f1;
          color: #e92127;
          border-radius: 50%;
          &:hover {
            background: #fef2f1;
            color: #e92127;
          }
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range {
          background: #fef2f1;
          color: #e92127;
          border-radius: 50%;
          &:hover {
            background: #fef2f1;
            color: #e92127;
          }
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range {
          background: #fef2f1;
          color: #e92127;
          border-radius: 50%;
          &:hover {
            background: #fef2f1;
            color: #e92127;
          }
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range.react-datepicker__day--selecting-range-start {
          background: #e92127 !important;
          color: #ffffff !important;
          border-radius: 50%;
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
          background: #e92127 !important;
          color: #ffffff !important;
          border-radius: 50%;
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end {
          background: #e92127 !important;
          color: #ffffff !important;
          border-radius: 50%;
        }
        .react-datepicker__day.react-datepicker__day--keyboard-selected.react-datepicker__day--in-range.react-datepicker__day--selecting-range-end {
          background: #e92127 !important;
          color: #ffffff !important;
          border-radius: 50%;
        }
      }
      .react-datepicker__day--range-end {
        background: #e92127 !important;
        color: #ffffff !important;
        border-radius: 50%;
      }
      .react-datepicker__day--range-start {
        background: #e92127 !important;
        color: #ffffff !important;
        border-radius: 50%;
      }
      .react-datepicker-popper {
        padding: 16px;
        background: var(--color-5);
        border-radius: 12px;
      }
      .react-datepicker__month,
      .react-datepicker {
        font-family: var(--font-body);
      }
      .react-datepicker__navigation--next {
        right: 10px;
      }
      .react-datepicker__navigation--previous {
        left: 10px;
      }
      .react-datepicker__week {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .react-datepicker__day--keyboard-selected,
      .react-datepicker__month-text--keyboard-selected,
      .react-datepicker__quarter-text--keyboard-selected,
      .react-datepicker__year-text--keyboard-selected {
        background: #e92127;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
      .react-datepicker__day--today {
        font-weight: 400;
      }
      .react-datepicker__navigation {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        top: 16px;
        flex: 0 0 auto;
        background: #ffffff;
        border: 1px solid #e92127;
      }
      .react-datepicker__navigation-icon--next::before {
        top: 55%;
        transform: translate(0, -50%) rotate(45deg);
        left: -3px;
        width: 8px;
        border-color: #e92127;
        height: 8px;
      }
      .react-datepicker__navigation-icon--previous::before {
        right: -3px;
        border-color: #e92127;
        transform: translate(0, -50%) rotate(225deg);
        top: 55%;
        width: 8px;
        height: 8px;
      }
      .react-datepicker__day--in-range {
        background: #fef2f1;
        color: #e92127;
        border-radius: 50%;
        &:hover {
          background: #fef2f1;
          color: #e92127;
        }
      }
      .react-datepicker__day--in-selecting-range {
        background: #fef2f1 !important;
        border-radius: 50% !important;
        color: #e92127;
        &:hover {
          background: #fef2f1 !important;
          border-radius: 50% !important;
          color: #e92127 !important;
        }
      }
      .react-datepicker__day {
        border-radius: 50%;
        transition: all 0.15s ease;
        &:hover {
          background: #e92127;
          border-radius: 50%;
          color: #fff;
        }
        &.react-datepicker__day--selected {
          background: #e92127 !important;
          color: #ffffff !important;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
      }
      .react-datepicker__day-names {
        display: flex;
      }
      .react-datepicker__portal .react-datepicker__day-name,
      .react-datepicker__portal .react-datepicker__day,
      .react-datepicker__portal .react-datepicker__time-name {
        width: 2rem;
        height: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .react-datepic_daker_y:hover {
        border-radius: 50%;
      }
      .react-datepicker__triangle {
        &::after,
        &::before {
          display: none;
        }
      }
      .react-datepicker {
        padding: 12px;
        border-radius: 20px;
        padding: 38px 40px;
      }
    }
  }
  .filter-header {
    padding: 0px 32px;
    background: #ffffff;
    width: 100%;
    @media (max-width: ${DESKTOP_WIDTH - 1}px) {
      padding: 0 16px;
    }
  }
  .list_all_ticket {
    width: 100%;
    background: #ffffff;
    padding: 0px 32px 32px 32px;
    border-radius: 0px 0px 20px 20px;
    box-shadow: 0px 20px 20px 0px #0000000d;
    display: flex;
    flex-direction: column;
    .--address {
      align-items: center;
    }
    .--title {
      color: #000000;
      font-size: 18px;
      font-weight: 600;
    }
    .--description {
      margin-top: 6px;
      color: #000000;
      // max-width: 360px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      margin-bottom: 6px;
      font-style: italic;
      font-size: 14px;
      margin-left: 4px;
    }
    .--price {
      color: #e92127;
      font-weight: 600;
    }
    .--price-old {
      color: #bdbdbd;
      font-weight: 500;
    }
    .--btn-book {
      background: #e92127;
      color: #ffffff;
      height: 40px;
      width: 102px;
      padding: 8px 3px;
      border-radius: 5px;
      border: none;
    }
    .--show-more {
      align-items: center;
      justify-content: center;
      color: #e92127;
      .ant-pagination-item-active {
        color: #e92127;
      }
      .ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
        color: #e92127;
      }
      .ant-pagination.ant-pagination-disabled .ant-pagination-item {
        border-color: #e92127;
        background-color: transparent;
      }
    }
    .--text-show-more {
      font-size: 16px;
      font-weight: 500;
      margin-right: 6px;
    }
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000000;
    font-size: 16px;
    font-weight: 600;
    text-shadow: 0 0 0.25px currentcolor;
  }
  .warning-ticket {
    margin-bottom: 10px;
    margin-top: -10px;
    color: #e55015;
    font-style: italic;
    display: flex;
    justify-content: end;
    margin-right: 24px;
  }
  .ant-tabs-ink-bar {
    position: absolute;
    background: #e92127;
    pointer-events: none;
  }
  .ant-tabs-tab {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 12px 0;
    font-size: 16px;
    background: transparent;
    border: 0;
    outline: none;
    cursor: pointer;
    color: #808080;
    font-weight: 600;
    &:hover {
      color: #000000;
    }
  }
  .box-left {
    /* position: -webkit-sticky;  Safari
  position: sticky; */
    top: 117px;
    @media (max-width: 1190px) {
      margin-bottom: 10px;
    }
  }
  .list-park {
    background: #ffffff;
    padding: 36px 25px;
    margin-bottom: 20px;
    border-radius: 20px;
    width: 306px;
    display: grid;
    gap: 33px;
  }
  .list-payment-method {
    background: #ffffff;
    padding: 36px 25px;
    margin-bottom: 20px;
    border-radius: 20px;
    width: 100%;
    display: grid;
    gap: 33px;
    @media (max-width: 1190px) {
      width: 100%;
    }
  }
  .ant-radio,
  .ant-radio-inner {
    width: 21px;
    height: 21px;
    top: 2px;
  }
  .ant-radio-checked .ant-radio-inner:after {
    content: url('/static/img/iconCheckRadio.svg');
    position: absolute;
    top: 48%;
    left: 55%;
    transform: translate(-10%, -10%);
    width: 0px;
    height: 12px;
    font-size: small;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #e92127;
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-checked,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #e92127;
  }
  .ant-radio-inner::after {
    background-color: #ffffff;
  }
  span.ant-radio + * {
    padding-right: 8px;
    padding-left: 8px;
    color: #000000;
  }
  .ant-radio-checked::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #e92127;
    border-radius: 50%;
    visibility: hidden;
    animation: antRadioEffect 0.36s ease-in-out;
    animation-fill-mode: both;
    content: '';
  }
  .header-park {
    margin-left: 6px;
    font-size: 18px;
    color: #000000;
    font-weight: 600;
  }
  .ant-pagination-options {
    display: none;
    margin-left: 16px;
    vertical-align: middle;
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    border: none;
    border-radius: 2px;
    outline: none;
    transition: all 0.3s;
    &:hover {
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .ant-pagination-item {
    border: none;
    border-radius: 50%;
    font-family: 'Be Vietnam Pro', sans-serif;
  }
  .ant-pagination-item-active {
    border-color: #e92127;
    border: 1px solid #e92127;
    &:hover {
      border-color: #e92127;
    }
  }
  .itemTicket {
    display: flex;
    margin-bottom: 12px;
    .--group-img {
      width: 310px;
      min-width: 310px;
      position: relative;
      margin-right: 16px;
      border-radius: 16px;
      height: 267px;
      img {
        border-radius: 16px;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
    .--discount-img {
      position: absolute;
      background-color: #e92127;
      top: 0;
      height: 32px;
      width: 65px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 18px;
    }
    .--discount-img::before {
      content: '';
      position: absolute;
      right: -16px;
      bottom: 0px;
      width: 0;
      height: 0;
      border-left: 16px solid #e92127;
      border-top: 16px solid transparent;
      border-bottom: 16px solid transparent;
    }
    .--learn-more {
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      width: 100%;
      text-align: center;
      justify-content: center;
      background: #f7dba1;
      height: 60px;
      background-color: #f8b11701;
      background-image: linear-gradient(to bottom, #f8b11701, #f8b117);
      color: #ffffff;
      border-radius: 16px;
      cursor: pointer;
    }
  }

  .group-detail-ticket {
    width: calc(100% - 310px);
    .--title {
      font-size: 16px;
      font-weight: 600;
      margin-top: 6px;
      font-weight: 600;
      color: #000000;
      width: 100%;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      @media (max-width: 1199px) {
        margin-top: 16px;
        margin-bottom: 12px;
      }
    }
    .--description {
      font-style: italic;
      color: #808080;
      margin-bottom: 4px;
    }
    .--group-gift {
      background-color: #fde9e9;
      color: #e92127;
      height: 33px;
      padding: 0px 10px;
      border-radius: 100px;
      margin-bottom: 6px;
      max-width: 190px;
    }
    .--label-gift {
      margin-left: 4px;
      font-size: 12px;
      // max-width: 200px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      color: #e92127;
    }
  }
  // .ant-tabs > .ant-tabs-nav, .ant-tabs > div > .ant-tabs-nav {
  //   position: relative;
  //   display: flex;
  //   flex: none;
  //   align-items: center;
  //   width: 50%;
  // }
  .btn-filter {
    width: 40px;
    height: 40px;
    background-color: #ffffff;
    margin-left: 6px;
    border: none;
    box-shadow: none;
    &:focus {
      border: none !important;
      box-shadow: none !important ;
      outline: none !important;
    }
    &:hover {
      border: none !important;
      box-shadow: none !important ;
      outline: none !important;
    }
  }
  button.ant-btn.ant-btn-default.btn-filter ::after {
    border: none !important;
    box-shadow: none !important ;
    outline: none !important;
    content: none !important;
    &:focus {
      border: none !important;
      box-shadow: none !important ;
      outline: none !important;
    }
    &:hover {
      border: none !important;
      box-shadow: none !important ;
      outline: none !important;
    }
  }
  .iconFilter {
    position: absolute;
    top: 0;
    left: 0;
  }
  .popover-content {
    .--title {
      font-weight: 600;
    }
  }
  label.ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
    font-weight: 600;
  }
  .form-inputNumber {
    width: 100px;
    height: 35px;
    display: flex;
    align-items: center;
    .ant-input-number-input {
      font-size: 14px;
    }
    .ant-input-number-group-addon {
      line-height: 22px;
      background: #ffffff;
    }
    .ant-input-number {
      max-width: 70px;
    }
  }
  .input-mobile {
    .ant-form-item-control-input-content {
      display: flex;
      justify-content: end;
    }
  }
  .ant-picker.custom-date-picker-ant {
    width: 80%;
    border: none;
    border-bottom: solid 1px #ededed;
    height: 40px;
    padding-left: 2px;
  }
  .ant-picker input::placeholder {
    color: #808080 !important;
    opacity: 1;
  }
  .ant-picker-suffix {
    color: #000000;
  }
  .ant-select-arrow {
    color: #000000;
  }
  .ant-select-status-error {
    border-color: 1px solid #ff4d4f !important;
  }
  .ant-picker-status-error {
    border-bottom: 1px solid red !important;
  }
  button.--btn-add-cart {
    border: 1px solid #fab317;
    border-radius: 12px;
    color: #fab317;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    /* padding: 0px 12px; */
    width: 145px;
  }
  button.--btn-buy-now {
    border: 1px solid #fab317;
    border-radius: 12px;
    background: #f17922;
    background-image: linear-gradient(to right, #f06f24, #f8b117);
    color: #ffffff;
    height: 40px;
    margin-left: 8px;
    width: 122px;
    white-space: nowrap;
  }
  button.--btn-buy-now:disabled {
    background-color: #cccccc; /* Greyed out color */
    color: #666666; /* Grey text */
    cursor: not-allowed; /* Indicate it's disabled */
    opacity: 0.6; /* Optional: makes it look faded */
    background-image: none;
    border: none;
  }
  .txt-label {
    font-weight: 400;
    font-size: 14px;
    height: 18px;
    margin-bottom: 5px;
    color: #000000;
  }
  .un-select {
    background: #ffffff !important;
    color: #fab317 !important;
    background-image: 'none';
  }

  .text-btn {
    margin-left: 6px;
  }
  span.css-1u9des2-indicatorSeparator {
    display: none;
  }
  .custom-select .css-13cymwt-control {
    border: none;
    box-shadow: none !important;
    border-bottom: 1px solid #c9c4c4;
    &:hover {
      border: none;
      box-shadow: none !important ;
      outline: none !important;
    }
  }
  .custom-select .css-t3ipsp-control {
    border: none;
    box-shadow: none !important;
    border-bottom: 1px solid #c9c4c4;
    &:hover {
      border: none;
      box-shadow: none !important ;
      outline: none !important;
    }
  }
  .driver {
    border-color: #d9d9d9;
    border-width: 2px 0 0;
  }
  .list-endow {
    background-color: #f8b117;
    background-image: linear-gradient(to bottom, #f8b117, #fffaef);
    border-radius: 20px;
    width: 306px;
    padding: 20px;
    .--title-list {
      text-transform: uppercase;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 26px;
      margin-top: 7px;
    }
    .--list {
      overflow-y: auto;
      // max-height: 90vh;
      ::-webkit-scrollbar {
        width: 6px;
      }
      ::-webkit-scrollbar-track {
        background: #f8b117;
      }
      ::-webkit-scrollbar-thumb {
        background: #ececec;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #ececec;
      }
      .--see-more {
        color: #f8b117;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .--item-endow {
      width: 100%;
      border-radius: 16px;
      margin-bottom: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 16px;
      }
    }
  }
  .prominent {
    img {
      object-fit: cover;
      border-radius: 16px;
      height: 216px;
    }
  }
  .title-prominent {
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin: 20px 0px;
    text-transform: uppercase;
  }
  .box-new {
    border-radius: 16px;
    background-color: #ffffff;
  }
  .group-new {
    background-color: #ffffff;
    border-radius: 0px 16px 16px 0px;
    padding: 24px;
    height: 224px;
  }
  .title-prominent-item {
    font-size: 18px;
    color: #000000;
    font-weight: 600;
    margin-bottom: 6px;
    text-align: justify;
    -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
  }
  .group-date-prominent {
    color: #808080;
    font-size: 12px;
  }
  .date-prominent {
    color: #808080;
    margin: 6px 0px 6px 4px;
  }
  .description-prominent {
    font-size: 12px;
    color: #000000;
    // max-width: 200px;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    text-align: justify;
  }
  .see-detail-prominent {
    position: absolute;
    bottom: 16px;
    color: #f8b117;
    cursor: pointer;
  }
  .custom-slice
    button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right {
    position: absolute;
    display: none;
    right: 0;
    background-color: #ffffff;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    border: none;
    box-shadow: 0px 10px 10px 0px #00000026;
  }
  .custom-slice
    button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right::before {
    color: #fab317;
  }
  .custom-slice
    button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left {
    position: absolute;
    display: none;
    left: 0;
    background-color: #ffffff;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    border: none;
    box-shadow: 0px 10px 10px 0px #00000026;
  }
  .custom-slice
    button.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left::before {
    color: #fab317;
  }
  label.ant-radio-wrapper {
    width: auto;
  }
  .group-see-stand {
    color: #f8b117;
    cursor: pointer;
  }
  .see-stand {
    margin-right: 4px;
  }
  .ant-pagination-prev {
    margin-bottom: 5px;
  }
  .ant-pagination-next {
    margin-bottom: 5px;
  }
  .dropdown-filter {
    border: 1px solid #d9d9d9;
    width: 210px;
    height: 44px;
    border-radius: 10px;
  }
  .input-filter {
    width: 90%;
    height: 100%;
    border: none;
    padding-left: 0px;
    overflow: hidden;
    color: #000000;
    white-space: nowrap;
    text-overflow: ellipsis;
    ::placeholder {
      color: #d9d9d9;
    }
    &:focus {
      border: none !important;
      box-shadow: none !important;
    }
  }
  .ant-tabs-top > .ant-tabs-nav:before {
    border-bottom: none;
  }
  .ant-pagination.ant-pagination-disabled .ant-pagination-item {
    background: #f5f5f5;
    border-color: #d9d9d9;
    cursor: not-allowed;
  }
  .ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
    color: rgba(0, 0, 0, 0.25);
    background: #fff;
    border-color: #d9d9d9;
    cursor: not-allowed;
  }
  .ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
    color: #808080;
  }
  .--description-name-park {
    color: #808080;
    margin-bottom: 4px;
    margin-top: 6px;
    margin-left: 4px;
    min-width: 160px;
    @media (max-width: 768px) {
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }
  .--description-note {
    font-style: italic;
    margin-top: 6px;
    color: #808080;
    margin-bottom: 4px;
    margin-left: 4px;
  }
  .txt-ticket-count {
    float: left;
    display: flex;
    flex: 1;
    justify-content: start;
  }
  .box-feature-ticket {
    display: flex;
    justify-content: space-between;
  }
  .txt-ticket-count {
    float: left;
    display: flex;
    flex: 1;
    justify-content: start;
  }
  .ant-form-item-explain-error {
    color: #e55015;
    font-style: italic;
    display: flex;
    justify-content: start;
  }
  .ticket-count {
    .ant-form-item-explain-error {
      margin-top: 5px;
      color: #e55015;
      font-style: italic;
      display: flex;
      justify-content: end;
      margin-left: -120px;
      text-align: end;
    }
    .ant-form-item-control {
      width: 100%;
      display: flex;
      flex: 1;
      align-items: end;
    }
  }
  @media (max-width: 1440px) {
    .ant-tabs {
      width: 100%;
    }
    .order-info {
      display: flex;
      flex-direction: column;
      position: inherit;
    }
    .box-order-total {
      width: 100%;
    }
    .order-info-box-right {
      width: 100%;
    }
    .order-info-box-left {
      width: 100%;
    }
  }
  @media (max-width: 1366px) {
    .box-feature-ticket {
      width: 100%;
    }
    .box-btn {
      width: 100%;
      display: flex;
    }
    .order-info-box-right {
      .txt-order-label {
        width: 300px;
      }
    }
    .order-info-box-left {
      .txt-order-label {
        width: auto;
      }
    }
    .group-see-stand {
      margin-top: 8px;
    }
    .--warning-ticket-prev {
      width: 35%;
      height: 0px;
    }
    .--warning-ticket {
      width: 300px;
      height: 15px;
    }
    .list-park {
      width: 260px;
    }
    .list-endow {
      width: 260px;
    }
  }
  @media (max-width: 1200px) {
    .custom-tab {
      .ant-tabs-nav {
        display: none;
      }
    }
    .select-catalog-mobile {
      width: 200px;
    }
    .ant-select-selector {
      height: 41px;
    }
    .ticketHead {
      .box-date {
        margin-left: auto;
      }
      width: 100%;
      display: flex;
      justify-content: space-between;
      .box-right-mobile {
      }
      .--currentSelectedDate {
        width: 41px;
        height: 41px;
        justify-content: center;
      }
      padding: 0px;
      margin-bottom: 16px;
    }
    .txt-label {
      display: none;
    }
    .btn-submit-search {
      display: none;
    }
    .dropdown-filter {
      width: 41px;
      padding: 10px;
      height: 41px;
      input {
        display: none;
      }
    }
    .box-item {
      width: 50%;
    }
    .--group-img {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      img {
        border-radius: 16px;
        height: 100%;
        object-fit: cover;
        width: 100% !important;
        max-width: 100%;
      }
    }
    .itemTicket {
      display: flex;
      flex-direction: column;
    }
    .itemTicket .--group-img {
      width: 100%;
      img {
        border-radius: 16px;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
    .group-detail-ticket {
      width: 100%;
    }
    .react-datepicker__input-container {
      color: #000000;
      font-size: 14px;
      // display: none
    }
    .txt-ticket-count {
      float: right;
      display: flex;
      flex: 1;
      justify-content: end;
    }
    .ticketHead {
      background: #ffffff;
      padding-bottom: 0px;
      border-radius: 16px 16px 0px 0px;
      /* justify-content: end !important; */
      display: flex !important;
    }
    .list_all_ticket {
      padding: 0px 16px;
    }
    .catalogTicketHead {
      padding: 0px !important;
    }
    button.--btn-add-cart {
      border: 1px solid #fab317;
      border-radius: 12px;
      color: #fab317;
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      padding: 0px 12px;
      font-weight: 600;
      width: 100%;
      white-space: nowrap;
    }
    button.--btn-buy-now {
      width: 100%;
      border: 1px solid #fab317;
      border-radius: 12px;
      background: #f17922;
      background-image: linear-gradient(to right, #f06f24, #f8b117);
      color: #ffffff;
      height: 45px;
      font-weight: 600;
      min-width: 130px;
      white-space: nowrap;
    }
    .group-see-stand {
      color: #f8b117;
      font-size: 14px;
    }
    .ant-picker.custom-date-picker-ant {
      width: 100%;
    }
    .--warning-ticket {
      width: 100%;
      height: 15px;
      display: flex;
      justify-content: end;
      margin-top: -10px;
    }
    .warning-ticket {
      margin-right: 0px;
    }
    #use-date-ticket {
      order: 1 !important;
      width: 100%;
    }
    #error-date {
      order: 1 !important;
    }
    #ticket-zone {
      order: 2 !important;
      padding-right: 15px;
    }
    #ticket-performance {
      order: 2 !important;
      padding-left: 15px;
    }
    #price-ticket {
      order: 4 !important;
    }
    #amount-ticket {
      order: 4 !important;
      display: flex;
      flex-direction: row-reverse;
    }
    #ticket-grandstand {
      order: 3 !important;
      width: 50%;
    }
    #ticket-inventory {
      order: 3 !important;
      width: 50%;
    }
    #ticket-submit {
      order: 5 !important;
      width: 100%;
    }
  }

  @media (max-width: 800px) {
    .warning-ticket {
      margin-right: 0px;
    }
    .group-new {
      background-color: #ffffff;
      padding: 24px;
      height: 224px;
      border-radius: 0px 0px 10px 10px;
    }
    .--driver {
      margin: -8px 0px -16px 0px;
    }
    .list_all_ticket {
      padding: 0px 16px;
    }
  }
`;
